// extracted by mini-css-extract-plugin
export default {"white":"travelLogo_white__2kZBv"};